import { Component, OnInit, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import { LoggedinService } from './services/login/loggedin.service';
import { SessionHelper } from './shared/services/localstorage';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import {Menus} from './models/menus/menus';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'papadmin';
  isLoggedIn: boolean;
  menu: Menus;
  constructor(private changeDetectorRef: ChangeDetectorRef, private router: Router, private loggedInService: LoggedinService) { 
    this.menu = new Menus();
  }

  ngOnInit() {    
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      window.scrollTo(0, 0);
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.loggedInService.currentStatus.subscribe((login:boolean) => {
        this.isLoggedIn=login;
      });
    }, 500);
  }

}
